import Patch from "@shared/models/patch-updater"

export const LESSON_TITLE_INTERMEDIATE_UPDATE = {
  name: "LESSON_TITLE_INTERMEDIATE_UPDATE",

  params: {
    value: "string",
    cardStackId: "string",
  },

  patches(payload) {
    let patch = Patch.create("card-stack", payload.cardStackId).set(
      "attributes.title",
      payload.value
    ).patch

    let patchForCardStackSummary = Patch.create("card-stack-summary", payload.cardStackId).set(
      "attributes.title",
      payload.value
    ).patch

    return [patchForCardStackSummary, patch]
  },

  undoPatches: null,

  narrative: null,
}

export default LESSON_TITLE_INTERMEDIATE_UPDATE
